import Theme from './Theme.css'
import Body from './Body.css'
import BodySupport from './BodySupport'
import Breadcrumbs from './Breadcrumbs.css'
import BreadcrumbsSupport from './BreadcrumbsSupport'
import Button from './Button.css'
import ButtonSupport from './ButtonSupport'
import Checkbox from './Checkbox.css'
import CheckboxSupport from './CheckboxSupport'
import ComboboxSupport from './ComboboxSupport'
import CompositeTextInput from './CompositeTextInput.css'
import CompositeTextInputSupport from './CompositeTextInputSupport'
import DataBlock from './DataBlock.css'
import DataBlockSupport from './DataBlockSupport'
import DateTimePicker from './DateTimePicker.css'
import DateTimePickerSupport from './DateTimePickerSupport'
import DateTimePickerV2 from './DateTimePickerV2.css'
import DateTimePickerV2Support from './DateTimePickerV2Support'
import DateTimeRangePicker from './DateTimeRangePicker.css'
import DateTimeRangePickerSupport from './DateTimeRangePickerSupport'
import DropdownSupport from './DropdownSupport'
import Flex from './Flex.css'
import FlexSupport from './FlexSupport'
import Label from './Label.css'
import LabelSupport from './LabelSupport'
import List from './List.css'
import ListSupport from './ListSupport'
import MultiSelectSupport from './MultiSelectSupport'
import MultiSelector from './MultiSelector.css'
import MultiSelectorSupport from './MultiSelectorSupport'
import Pane from './Pane.css'
import PaneSupport from './PaneSupport'
import Popup from './Popup.css'
import PopupSupport from './PopupSupport'
import Portal from './Portal.css'
import PortalSupport from './PortalSupport'
import ProgressBar from './ProgressBar.css'
import ProgressBarSupport from './ProgressBarSupport'
import PropertyGrid from './PropertyGrid.css'
import PropertyGridSupport from './PropertyGridSupport'
import RadioButton from './RadioButton.css'
import RadioButtonSupport from './RadioButtonSupport'
import Slider from './Slider.css'
import SliderSupport from './SliderSupport'
import SplitPane from './SplitPane.css'
import SplitPaneSupport from './SplitPaneSupport'
import TabPane from './TabPane.css'
import TabPaneSupport from './TabPaneSupport'
import Table from './Table.css'
import TableSupport from './TableSupport'
import TableV2 from './TableV2.css'
import TableV2Support from './TableV2Support'
import Text from './Text.css'
import TextSupport from './TextSupport'
import TextArea from './TextArea.css'
import TextAreaSupport from './TextAreaSupport'
import TextInput from './TextInput.css'
import TextInputSupport from './TextInputSupport'
import Toast from './Toast.css'
import ToastSupport from './ToastSupport'
import Toggle from './Toggle.css'
import ToggleSupport from './ToggleSupport'
import ToggleButton from './ToggleButton.css'
import ToggleButtonSupport from './ToggleButtonSupport'
import VTableSupport from './VTableSupport'
import ElementSupport from './ElementSupport'


function addScript( src ) {
  const script = document.createElement( "script" )
  script.crossOrigin = "anonymous"
  script.src = src
  document.head.appendChild( script )
}

addScript( 'https://kit.fontawesome.com/8846456f0e.js' )


const styles = {
  Body,
  Breadcrumbs,
  Button,
  Checkbox,
  CompositeTextInput,
  DataBlock,
  DateTimePicker,
  DateTimePickerV2,
  DateTimeRangePicker,
  Flex,
  Label,
  List,
  MultiSelector,
  Pane,
  Popup,
  Portal,
  ProgressBar,
  PropertyGrid,
  RadioButton,
  Slider,
  SplitPane,
  TabPane,
  Table,
  TableV2,
  Text,
  TextArea,
  TextInput,
  Toast,
  Toggle,
  ToggleButton
}
const supports = {
  Body : BodySupport,
  Breadcrumbs : BreadcrumbsSupport,
  Button : ButtonSupport,
  Checkbox : CheckboxSupport,
  Combobox : ComboboxSupport,
  CompositeTextInput : CompositeTextInputSupport,
  DataBlock : DataBlockSupport,
  DateTimePicker : DateTimePickerSupport,
  DateTimePickerV2 : DateTimePickerV2Support,
  DateTimeRangePicker : DateTimeRangePickerSupport,
  Dropdown : DropdownSupport,
  Flex : FlexSupport,
  Label : LabelSupport,
  List : ListSupport,
  MultiSelect : MultiSelectSupport,
  MultiSelector : MultiSelectorSupport,
  Pane : PaneSupport,
  Popup : PopupSupport,
  Portal : PortalSupport,
  ProgressBar : ProgressBarSupport,
  PropertyGrid : PropertyGridSupport,
  RadioButton : RadioButtonSupport,
  Slider : SliderSupport,
  SplitPane : SplitPaneSupport,
  TabPane : TabPaneSupport,
  Table : TableSupport,
  TableV2 : TableV2Support,
  Text : TextSupport,
  TextArea : TextAreaSupport,
  TextInput : TextInputSupport,
  Toast : ToastSupport,
  Toggle : ToggleSupport,
  ToggleButton : ToggleButtonSupport,
  VTable : VTableSupport,
  Element : ElementSupport
}
const color = {
  "FocusVisBorder": "#4ba5f5",
  "attributeCellEditable": "@color:brand300",
  "base025": "#f9fafb",
  "base050": "#f4f7fd",
  "base100": "#e7eaf2",
  "base200": "#ced6de",
  "base300": "#acb7c3",
  "base400": "#95a2b2",
  "base500": "#67798e",
  "base600": "#495a6e",
  "base700": "#394756",
  "base800": "#29323d",
  "base900": "#181e25",
  "brand025": "#f0f6ff",
  "brand050": "#d5e6fd",
  "brand100": "#b9d5fb",
  "brand200": "#82b1f6",
  "brand300": "#5391ee",
  "brand400": "#2f77e4",
  "brand500": "#1661d7",
  "brand600": "#0b58c8",
  "brand700": "#0651b5",
  "brand800": "#03489f",
  "brand900": "#003f87",
  "columnValue": "@color:base600",
  "danger050": "#ffebed",
  "danger100": "#fdd8dd",
  "danger500": "#cb3c48",
  "danger700": "#aa2a30",
  "danger900": "#65171c",
  "detailEvenRow": "rgba(243, 245, 246, 0.46)",
  "detailOddRow": "transparent",
  "dropTarget": "@color:base100",
  "graphBackground": "#ffffff",
  "graphSeries1": "#2258c0",
  "graphSeries10": "#976a41",
  "graphSeries2": "#f4b85d",
  "graphSeries3": "#e7803e",
  "graphSeries4": "#b057d4",
  "graphSeries5": "#f4dc5d",
  "graphSeries6": "#6ab3a4",
  "graphSeries7": "#5b8bf6",
  "graphSeries8": "#42c6c8",
  "graphSeries9": "#cb4183",
  "graphThreshold": "@color:danger700",
  "graphXAxisLabel": "@color:base700",
  "graphXAxisLine": "@color:base200",
  "graphXTickLabel": "@color:base700",
  "graphYAxisLabel": "@color:base700",
  "graphYAxisLine": "@color:base200",
  "graphYTickLabel": "@color:base700",
  "linkHover": "#0044cc",
  "linkNormal": "#0f5dfa",
  "linkVisited": "#5288f4",
  "mainNavPane": "#181e25",
  "overlay": "#808080",
  "secondaryBrand050": "#ddf7f2",
  "secondaryBrand100": "#c8efe8",
  "secondaryBrand500": "#4db5a3",
  "secondaryBrand700": "#299e87",
  "secondaryBrand900": "#308282",
  "shadowBase": "rgba(41, 50, 61, 0.16)",
  "sort100": "#add5dd",
  "sort50": "#d3e7eb",
  "sort500": "#0c8599",
  "success050": "#edfdf8",
  "success100": "#dafbf0",
  "success300": "#1ae5a1",
  "success500": "#15b982",
  "success700": "#0e815a",
  "success900": "#084934",
  "tableFiltered": "rgba(190, 208, 249, 0.2)",
  "tableRollover": "@color:brand025",
  "tableRolloverSelected": "@color:brand200",
  "tableSelected": "@color:brand100",
  "tableSorted": "rgba(211, 231, 235, 0.32)",
  "tertiaryBrandA": "#15b982",
  "tertiaryBrandA300": "#ff9f5f",
  "tertiaryBrandA500": "#f67a28",
  "tertiaryBrandB": "#ffb647",
  "tertiaryBrandB300": "#fdcd84",
  "tertiaryBrandB500": "#ffb647",
  "tertiaryBrandC": "#f67a28",
  "tertiaryBrandC300": "#42d3a3",
  "tertiaryBrandC500": "#15b982",
  "tertiaryBrandD": "#0f5dfa",
  "tertiaryBrandD300": "#4f89ff",
  "tertiaryBrandD500": "#0f5dfa",
  "warning050": "#ffefd6",
  "warning100": "#fde7d8",
  "warning500": "#ffb647",
  "warning700": "#ef8808",
  "warning900": "#7a4a00",
  "white": "#ffffff",
  "ScreenIcon": "@color:brand500",
  "ScreenIconBackground": "@color:brand025",
  "SideNavCollapseBackground": "@color:white",
  "SideNavCollapseBorder": "@color:base200",
  "SideNavDivider": "@color:base200",
  "SideNavHeader": "@color:base500",
  "SideNavHover": "@color:brand100",
  "SideNavIcon": "@color:brand500",
  "SideNavOn": "@color:brand050",
  "SideNavPane": "@color:white",
  "SideNavPressed": "@color:brand100",
  "SideNavText": "@color:base700",
  "SideNavTextSelected": "@color:brand500",
  "TopNavBorder": "@color:brand500",
  "TopNavDivider": "@color:base200",
  "TopNavHover": "@color:brand100",
  "TopNavIcon": "@color:brand500",
  "TopNavOn": "@color:brand050",
  "TopNavPane": "@color:white",
  "TopNavPressed": "@color:brand100",
  "TopNavText": "@color:base700",
  "TopNavTextSelected": "@color:brand500"
}
const icon = {
  "add-group": "fak fa-lv-add-group",
  "aggregate-bar-chart": "fak fa-lv-dv-aggregate-bar-chart",
  "aggregate-pie-chart": "fak fa-lv-aggregate-pie-chart",
  "all-items-dashboard": "fak fa-lv-all-items-dashboard",
  "api-access-key": "fak fa-lv-api-access-key-large",
  "architect-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-call-architect.svg",
  "arrow-left": "fak fa-lv-arrow-right",
  "arrow-right": "fak fa-lv-arrow-right",
  "associated-id": "fak fa-lv-associated-id",
  "attribute-pie-chart": "fak fa-lv-attribute-pie-chart",
  "bulk-create": "fak fa-lv-bulk-create",
  "calendar": "fak fa-lv-calendar",
  "camera": "fak fa-lv-camera",
  "cancel": "fak fa-lv-cancel",
  "center-address": "fak fa-lv-center-address",
  "check": "fa-solid fa-check",
  "chevron-down-large": "fak fa-lv-chevron-down-large",
  "chevron-down-small": "fak fa-lv-chevron-down-small",
  "chevron-left-large": "fak fa-lv-chevron-left-large",
  "chevron-left-small": "fak fa-lv-chevron-left-small",
  "chevron-right-large": "fak fa-lv-chevron-right-large",
  "chevron-right-small": "fak fa-lv-chevron-right-small",
  "chevron-up-large": "fak fa-lv-chevron-up-large",
  "chevron-up-small": "fak fa-lv-chevron-up-small",
  "clear": "fak fa-lv-clear",
  "close": "fak fa-lv-cancel",
  "compute-agg-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-compute-aggregation.svg",
  "conditionSelector": "fa fa-fw fa-dog",
  "configuration": "fak fa-lv-configuration",
  "copy": "fak fa-lv-copy",
  "copy-to-clipboard": "fak fa-lv-copy",
  "cow": "fa-kit fa-lv-cow",
  "create": "fak fa-lv-create",
  "current-location": "fak fa-lv-current-location",
  "dash": "fak fa-lv-dash",
  "dashboard": "fak fa-lv-dashboard",
  "delete": "fak fa-lv-delete",
  "details": "fak fa-lv-details",
  "details-block": "fak fa-lv-details-block",
  "details-filled": "fak fa-lv-details-filled",
  "edit": "fak fa-lv-edit",
  "edit-device-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-edit-device-attribute.svg",
  "email-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-send-email.svg",
  "event-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-create-event.svg",
  "farm": "fa-kit fa-lv-farm",
  "farm-corporation": "fa-kit fa-lv-farm-corporation",
  "filter": "fak fa-lv-filter",
  "gear": "fak fa-lv-gear",
  "geoshape-nearest-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-get-nearest-geoshape.svg",
  "grabberIcon": "fak fa-lv-rearrange",
  "grid": "fak fa-lv-dv-grid",
  "grid-options": "fak fa-lv-grid-options",
  "group": "fak fa-lv-group",
  "group-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-rule-group.svg",
  "hardware": "fak fa-lv-hardware",
  "help": "fak fa-lv-help",
  "help-filled": "fak fa-lv-help-filled",
  "hide": "fak fa-lv-hide",
  "history-pie-chart": "fak fa-lv-history-pie-chart",
  "history-table-list": "fak fa-lv-dv-history-table-list",
  "history-table-list-filled": "fa-kit fa-lv-dv-history-table-list-filled",
  "history-xy-chart": "fak fa-lv-dv-history-xy-chart",
  "if-then": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-if-then.svg",
  "image": "fak fa-lv-image",
  "info": "fak fa-lv-info",
  "info-filled": "fak fa-lv-info-filled",
  "layout": "fak fa-lv-layout",
  "load-form": "fak fa-lv-load-form",
  "log-out": "fak fa-lv-log-out",
  "log-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-log-value-source.svg",
  "low-battery": "fa-regular fa-battery-quarter",
  "lvg-logo": "fak fa-lv-lvg-logo",
  "map": "fak fa-lv-dv-map",
  "menu": "fak fa-lv-menu",
  "more": "fa-solid fa-ellipsis-vertical",
  "more-h": "fa fa-ellipsis fa-fw",
  "multi-image": "fak fa-lv-multi-image",
  "operating-hours-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-operating-hours.svg",
  "overrideFormIcon": "fak fa-lv-refresh",
  "pair": "fak fa-lv-pair",
  "placeholder": "fak fa-lv-placeholder",
  "profileMenu": "fa-kit fa-lv-avatar-placeholder",
  "rearrange": "fak fa-lv-rearrange",
  "refresh": "fak fa-lv-refresh",
  "remove": "fak fa-lv-remove",
  "reset": "fa-regular fa-rotate-left",
  "rules": "fa-kit fa-lv-rules",
  "satellite": "fak fa-lv-satellite",
  "save": "fa-regular fa-arrow-down-to-bracket",
  "save-to": "fak fa-lv-save-to",
  "search": "fak fa-lv-search",
  "search-geoshapes-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-search-geoshapes.svg",
  "selected-items-dashboard": "fak fa-lv-selected-items-dashboard",
  "set-var": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-set-variable.svg",
  "settings": "fak fa-lv-settings",
  "settings-gear-filled": "fak fa-lv-settings-gear-filled",
  "show": "fak fa-lv-show",
  "single-image": "fak fa-lv-single-image",
  "slack-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-slack-message.svg",
  "sms-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-send-sms.svg",
  "sort": "fak fa-lv-sort",
  "stop": "fak fa-lv-stop",
  "success": "fak fa-lv-success",
  "table-list": "fak fa-lv-dv-table-list",
  "time": "fak fa-lv-time",
  "transfer": "fak fa-lv-transfer",
  "trash": "fak fa-lv-delete",
  "unpair": "fak fa-lv-unpair",
  "update": "fak fa-lv-update",
  "upload": "fak fa-lv-upload",
  "user": "fak fa-lv-user",
  "users": "fa-kit fa-lv-users",
  "warning-filled": "fak fa-lv-warning-filled",
  "webhook-rule": "https://storage.googleapis.com/molten-ui-assets/Rules%20Engine%20Icons/nav-call-webhook.svg",
  "battery-bolt": "fa-regular fa-battery-bolt",
  "check-small": "fa-solid fa-ball-pile",
  "chevron-down": "fa-solid fa-filter",
  "circle-stop": "fa-regular fa-circle-stop",
  "icon-chat": "fak fa-lv-icon-chat",
  "link-out": "fak fa-lv-link-out",
  "pin": "fak fa-lv-pin",
  "tag": "fak fa-lv-recovr-tag",
  "tag-ringing": "fak fa-lv-recovr-tag-ringing"
}
const size = {
  "attributeCellEditable": "2px",
  "borderRadiusLarge": "8px",
  "borderRadiusMedium": "4px",
  "borderRadiusSmall": "2px",
  "fontBody": "16px",
  "fontBodySmall": "15px",
  "fontButtonMedium": "15px",
  "fontButtonSmall": "12px",
  "fontCaption": "13px",
  "fontCaptionSmall": "12px",
  "fontH1": "20px",
  "fontH2": "18px",
  "fontH3": "16px",
  "large": "16px",
  "medium": "8px",
  "negative": "-4px",
  "pad12": "12px",
  "padLarge": "16px",
  "padMedium": "8px",
  "padSmall": "4px",
  "padXLarge": "24px",
  "padXXLarge": "32px",
  "portalMaxWidth": "504px",
  "propertyGridColumnGap": "8px",
  "propertyGridRowGap": "8px",
  "small": "4px"
}
const resources = { color, icon, size }

export default { styles, supports, resources }